import { render, staticRenderFns } from "./WhoisPhone.vue?vue&type=template&id=2496cb79&"
import script from "./WhoisPhone.vue?vue&type=script&lang=js&"
export * from "./WhoisPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports